import { useState, useEffect, useCallback } from 'react';
import FeedCard from '@/components/feed/FeedCard';
import CreatePostBox from '@/components/feed/CreatePostBox';
import CreatePostModal from '@/components/feed/CreatePostModal';
import RightSidebar from '@/components/layout/RightSidebar';
import { getStore } from '@/utils/localStore';

const filterTabs = [
  { label: 'All', value: null },
  { label: 'Updates', value: 'ngo_update' },
  { label: 'Donations', value: 'donation_milestone' },
  { label: 'Milestones', value: 'project_milestone' },
  { label: 'Volunteer', value: 'volunteer_activity' },
  { label: 'Stories', value: 'impact_story' },
  { label: 'Launches', value: 'fundraiser_launch' },
];

function FeedSkeleton() {
  return (
    <div className="space-y-4">
      {[...Array(3)].map((_, i) => (
        <div key={i} className="bg-white rounded-xl border border-slate-200 p-5 animate-pulse">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-full bg-slate-200" />
            <div className="space-y-1.5"><div className="w-32 h-3 rounded bg-slate-200" /><div className="w-16 h-2 rounded bg-slate-100" /></div>
          </div>
          <div className="space-y-2 mb-4"><div className="w-full h-3 rounded bg-slate-200" /><div className="w-3/4 h-3 rounded bg-slate-200" /></div>
          <div className="w-full h-44 rounded-lg bg-slate-100" />
        </div>
      ))}
    </div>
  );
}

export default function FeedPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState(null);
  const [showCreate, setShowCreate] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch('/data/feed_posts.json')
      .then(r => r.json())
      .then(all => {
        const userPosts = getStore('user_posts').slice(-10).reverse();
        const filteredStatic = activeFilter ? all.filter(p => p.type === activeFilter) : all;
        const filteredUser = activeFilter ? userPosts.filter(p => p.type === activeFilter) : userPosts;
        setPosts([...filteredUser, ...filteredStatic]);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [activeFilter]);

  const handlePostCreated = useCallback((newPost) => {
    setPosts(prev => [newPost, ...prev]);
  }, []);

  return (
    <div className="flex max-w-[1100px] mx-auto" data-testid="feed-page">
      <div className="flex-1 max-w-[600px] mx-auto px-2 sm:px-4 py-4">
        <CreatePostBox onOpenCreate={() => setShowCreate(true)} />

        <div className="flex items-center gap-1 overflow-x-auto pb-1 mb-4 scrollbar-hide" data-testid="feed-filters">
          {filterTabs.map(tab => (
            <button
              key={tab.label}
              onClick={() => setActiveFilter(tab.value)}
              className={`px-3.5 py-1.5 rounded-lg text-xs font-medium whitespace-nowrap transition-colors ${
                activeFilter === tab.value ? 'bg-[#7C3AED] text-white' : 'bg-white text-slate-500 border border-slate-200 hover:bg-slate-50'
              }`}
              data-testid={`filter-${tab.label.toLowerCase()}`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {loading ? <FeedSkeleton /> : (
          <div className="space-y-4">
            {posts.map((post, i) => <FeedCard key={post.id} post={post} index={i} />)}
            {posts.length === 0 && <div className="text-center py-12 text-slate-400 text-sm">No posts in this category.</div>}
          </div>
        )}
      </div>
      <RightSidebar />
      <CreatePostModal open={showCreate} onClose={() => setShowCreate(false)} onPostCreated={handlePostCreated} />
    </div>
  );
}
